import { render, staticRenderFns } from "./candidate_civil_state_result.vue?vue&type=template&id=771f64bc&scoped=true&"
import script from "./candidate_civil_state_result.vue?vue&type=script&lang=js&"
export * from "./candidate_civil_state_result.vue?vue&type=script&lang=js&"
import style0 from "./candidate_civil_state_result.vue?vue&type=style&index=0&id=771f64bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771f64bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('771f64bc')) {
      api.createRecord('771f64bc', component.options)
    } else {
      api.reload('771f64bc', component.options)
    }
    module.hot.accept("./candidate_civil_state_result.vue?vue&type=template&id=771f64bc&scoped=true&", function () {
      api.rerender('771f64bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/metrics/candidate_civil_state_result.vue"
export default component.exports